export const defaultTemplates = {
  notifications: {
    bookingConfirmation: false,
    appointmentReminders: false,
    schedulingUpdates: false,
    depositConfirmation: false,
    balanceConfirmation: false,
    checkInLinkRequest: false
  },
  templates: {
    bookingConfirmation: {
      subject: "Your Appointment is Confirmed!",
      body: `
      <div style="font-family: Arial, sans-serif; max-width: 600px; margin: 0; text-align: left; color: #0f172a;">
        <p style="margin: 0 0 14px; font-size: 16px; line-height: 1.7;">Dear {{customerName}},</p>
        <p style="margin: 0 0 22px; font-size: 15px; line-height: 1.75; color: #475569;">Your appointment has been confirmed, and we are looking forward to seeing you. Here are the details:</p>
        <h3 style="margin: 0 0 14px; color: #1976d2; font-size: 16px;">Appointment details</h3>
        <p style="margin: 0 0 12px; line-height: 1.7;"><strong style="color: #0f172a;">Service:</strong> {{service}}</p>
        <p style="margin: 0 0 12px; line-height: 1.7;"><strong style="color: #0f172a;">Date:</strong> {{date}}</p>
        <p style="margin: 0 0 24px; line-height: 1.7;"><strong style="color: #0f172a;">Time:</strong> {{time}}</p>
        <p style="margin: 0 0 14px; font-size: 15px; line-height: 1.75; color: #475569;">If you need to make any changes, you can use your client portal or contact us directly.</p>
        <p style="margin: 0; font-size: 15px; line-height: 1.75;">Thank you for choosing us.</p>
      </div>
      `,
      enabled: true
    },
    appointmentReminder: {
      subject: "Reminder: Your Upcoming Appointment",
      body: `
      <div style="font-family: Arial, sans-serif; max-width: 600px; margin: 0; text-align: left; color: #0f172a;">
        <p style="margin: 0 0 14px; font-size: 16px; line-height: 1.7;">Dear {{customerName}},</p>
        <p style="margin: 0 0 22px; font-size: 15px; line-height: 1.75; color: #475569;">This is a friendly reminder about your upcoming appointment.</p>
        <h3 style="margin: 0 0 14px; color: #1976d2; font-size: 16px;">Appointment details</h3>
        <p style="margin: 0 0 12px; line-height: 1.7;"><strong style="color: #0f172a;">Service:</strong> {{service}}</p>
        <p style="margin: 0 0 12px; line-height: 1.7;"><strong style="color: #0f172a;">Date:</strong> {{date}}</p>
        <p style="margin: 0 0 24px; line-height: 1.7;"><strong style="color: #0f172a;">Time:</strong> {{time}}</p>
        <p style="margin: 0 0 14px; font-size: 15px; line-height: 1.75; color: #475569;">If you need to reschedule or have any questions, you can use your client portal or contact us directly.</p>
        <p style="margin: 0; font-size: 15px; line-height: 1.75;">We look forward to welcoming you.</p>
      </div>
      `,
      enabled: true
    },
    depositConfirmation: {
      subject: "Deposit Payment Confirmation - {{service}}",
      body: `
        <div style="font-family: Arial, sans-serif; max-width: 600px; margin: 0; text-align: left; color: #0f172a;">
          <p style="margin: 0 0 14px; font-size: 16px; line-height: 1.7;">Dear {{customerName}},</p>
          <p style="margin: 0 0 22px; font-size: 15px; line-height: 1.75; color: #475569;">Thank you for your deposit payment. Here is a quick summary of your appointment and payment details.</p>
          <h3 style="margin: 0 0 14px; color: #1976d2; font-size: 16px;">Payment details</h3>
          <p style="margin: 0 0 12px; line-height: 1.7;"><strong style="color: #0f172a;">Service:</strong> {{service}}</p>
          <p style="margin: 0 0 12px; line-height: 1.7;"><strong style="color: #0f172a;">Date:</strong> {{date}}</p>
          <p style="margin: 0 0 12px; line-height: 1.7;"><strong style="color: #0f172a;">Time:</strong> {{time}}</p>
          <p style="margin: 0 0 12px; line-height: 1.7;"><strong style="color: #0f172a;">Deposit paid:</strong> {{depositAmount}}</p>
          <p style="margin: 0 0 24px; line-height: 1.7;"><strong style="color: #0f172a;">Remaining balance:</strong> {{remainingBalance}}</p>
          <p style="margin: 0 0 14px; font-size: 15px; line-height: 1.75; color: #475569;">The remaining balance of {{remainingBalance}} can be paid before or during your appointment.</p>
          <p style="margin: 0; font-size: 15px; line-height: 1.75;">If you have any questions about your payment or appointment, please contact us using the business details provided.</p>
        </div>
      `,
      enabled: true
    },
    balanceConfirmation: {
      subject: "Payment Confirmation - {{service}}",
      body: `
        <div style="font-family: Arial, sans-serif; max-width: 600px; margin: 0; text-align: left; color: #0f172a;">
          <p style="margin: 0 0 14px; font-size: 16px; line-height: 1.7;">Dear {{customerName}},</p>
          <p style="margin: 0 0 22px; font-size: 15px; line-height: 1.75; color: #475569;">Thank you for completing your payment. Your appointment is now fully paid, and everything is set.</p>
          <h3 style="margin: 0 0 14px; color: #1976d2; font-size: 16px;">Payment details</h3>
          <p style="margin: 0 0 12px; line-height: 1.7;"><strong style="color: #0f172a;">Service:</strong> {{service}}</p>
          <p style="margin: 0 0 12px; line-height: 1.7;"><strong style="color: #0f172a;">Date:</strong> {{date}}</p>
          <p style="margin: 0 0 12px; line-height: 1.7;"><strong style="color: #0f172a;">Time:</strong> {{time}}</p>
          <p style="margin: 0 0 12px; line-height: 1.7;"><strong style="color: #0f172a;">Balance paid:</strong> {{balanceAmount}}</p>
          <p style="margin: 0 0 24px; line-height: 1.7;"><strong style="color: #0f172a;">Total amount:</strong> {{totalAmount}}</p>
          <p style="margin: 0 0 14px; font-size: 15px; line-height: 1.75; color: #475569;">We appreciate your business and look forward to seeing you soon.</p>
          <p style="margin: 0; font-size: 15px; line-height: 1.75;">If you have any questions about your payment or appointment, please contact us using the business details provided.</p>
        </div>
      `,
      enabled: true
    },
    checkInLinkRequest: {
      subject: 'Check in for your appointment — {{service}}',
      body: `
        <div style="font-family: Arial, sans-serif; max-width: 600px; margin: 0; text-align: left; color: #0f172a;">
          <p style="margin: 0 0 14px; font-size: 16px; line-height: 1.7;">Dear {{customerName}},</p>
          <p style="margin: 0 0 22px; font-size: 15px; line-height: 1.75; color: #475569;">Your appointment is coming up soon. When you arrive, use the link below to check in.</p>
          <h3 style="margin: 0 0 14px; color: #1976d2; font-size: 16px;">Appointment details</h3>
          <p style="margin: 0 0 12px; line-height: 1.7;"><strong style="color: #0f172a;">Service:</strong> {{service}}</p>
          <p style="margin: 0 0 12px; line-height: 1.7;"><strong style="color: #0f172a;">Date:</strong> {{date}}</p>
          <p style="margin: 0 0 12px; line-height: 1.7;"><strong style="color: #0f172a;">Time:</strong> {{time}}</p>
          <p style="margin: 0 0 24px; line-height: 1.7;"><a href="{{checkInUrl}}" style="color: #1976d2; font-weight: 600;">Check in now</a></p>
          <p style="margin: 0; font-size: 15px; line-height: 1.75; color: #475569;">If the link does not work, copy and paste this URL into your browser: {{checkInUrl}}</p>
        </div>
      `,
      enabled: true
    },
    scheduleChange: {
      subject: "Your Appointment Has Been Rescheduled",
      body: `
        <div style="font-family: Arial, sans-serif; max-width: 600px; margin: 0; text-align: left; color: #0f172a;">
          <p style="margin: 0 0 14px; font-size: 16px; line-height: 1.7;">Dear {{customerName}},</p>
          <p style="margin: 0 0 22px; font-size: 15px; line-height: 1.75; color: #475569;">Your appointment for {{service}} has been moved to a new time. We wanted to share the updated details with you right away.</p>
          <h3 style="margin: 0 0 14px; color: #1976d2; font-size: 16px;">Updated appointment details</h3>
          <p style="margin: 0 0 12px; line-height: 1.7;"><strong style="color: #0f172a;">Original date & time:</strong> {{oldDate}} {{oldTime}}</p>
          <p style="margin: 0 0 24px; line-height: 1.7;"><strong style="color: #0f172a;">New date & time:</strong> {{newDate}} {{newTime}}</p>
          <p style="margin: 0 0 14px; font-size: 15px; line-height: 1.75; color: #475569;">If you need anything else, you can use your client portal or contact us directly.</p>
          <p style="margin: 0; font-size: 15px; line-height: 1.75;">Thank you for your flexibility and understanding.</p>
        </div>
      `,
      enabled: true
    }
  },
  reminderEnabled: false,
  reminders: []
};

export const mergeEmailSettingsWithDefaults = (settings = {}) => {
  const savedTemplates = settings?.templates || {};

  return {
    ...defaultTemplates,
    ...(settings || {}),
    notifications: {
      ...defaultTemplates.notifications,
      ...(settings?.notifications || {})
    },
    templates: Object.keys(defaultTemplates.templates).reduce(
      (mergedTemplates, templateKey) => ({
        ...mergedTemplates,
        [templateKey]: {
          ...defaultTemplates.templates[templateKey],
          ...(savedTemplates[templateKey] || {})
        }
      }),
      { ...savedTemplates }
    )
  };
};